import Permission from 'owa-service/lib/contract/Permission';
import { getStore } from '../store/store';

/**
 * Function will return current selected permission.
 * @returns Current selected permission object in UI store.
 */
export default function getSelectedPermission(): Permission {
    const { selectedPermissionIndex, permissions } = getStore();
    return permissions[selectedPermissionIndex];
}
